import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from "react-router-dom";
// API
import { AMS } from "../../services/api";
// Notifications
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';
// Spreadsheet control
import { Spreadsheet } from "@progress/kendo-spreadsheet-react-wrapper";
/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { BiArrowFromRight } from "react-icons/bi";
import './wizard.css'
// Spinner
import { Loader } from "@progress/kendo-react-indicators";

/**This component will render the entire Wizard actions. All the steps and wizard info will be render here*/
function ModelReports() {
    //* To can acess the parameters sent via history.push
    const location = useLocation();
    /**Used to translate the text*/
    const { t } = useTranslation('common');
    /**We use useHistory hook to redirect */
    const history = useHistory();
    // States
    const [selectedReport, setSelectedReport] = useState('rpt012_cmp_scn_b')
    // 
    const [reportsList, setReportsList] = useState([]);
    //ref to the spread
    const spread = useRef(null);
    // if we need change the dimension of rows or columns of the spread, we need no show the spread, so that it reload
    const [showSpread, setShowSpread] = useState(false);
    //handle rows and columns sizes
    const [spreadDim, setSpreadDim] = useState({ rows: 1, columns: 1 });
    // * State variable used to hide the spinner if the report does not even have data. response.data.data === null
    const [showSpinner, setShowSpinner] = useState(true)

    /**Triggered when user clicks "Go Back" button. Redirects to Models view*/
    const goBack = () => {
        history.push('/Models');
    }

    // This useEffect is used to fill the combobox
    useEffect(() => {
        // API call to fill the comboBox
        getComboboxData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Calls the API to get the list of reports. This list will be used to fill the combobox
    // Sets the list of reports as state
    const getComboboxData = async () => {
        try{
            const response = await AMS.get(`/reportlist/MODEL/${location.state.detail.modelid}`);
            setReportsList(response.data.data);
        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error)
        }
    }

    // This useEffect is used to get the selected reporta data and show it in the spreadsheet
    useEffect(() => {
        // API call to fill the spreadhseet
        getReportData(selectedReport);
    }, [selectedReport]); // eslint-disable-line react-hooks/exhaustive-deps

    const getReportData = async (code) => {
        try {
            // Hides the spreadsheet to avoid errors
            setShowSpread(false);
            // API call to get the Report data
            const response = await AMS.get(`/report/MODEL/${location.state.detail.modelid}/${code}`);
            // Shows error message if the api call fails
            if (response.data.result === -1) {
                Notifications.notify(response.data.message, ERROR_NOTIFICATION);
                
                setShowSpinner(false);
                return;
            }
            // if data is null
            if (response.data.data === null) {
                Notifications.notify(t('model.dataNull'), ERROR_NOTIFICATION);
                
                setShowSpinner(false);
                return;
            }
            // If the model does not have scenarios
            if(response.data.result === -404000){
                Notifications.notify(t('model.modelWithoutScenarios'), ERROR_NOTIFICATION);
                
                setShowSpinner(false);
                return;
            }
            // if everything OK, the data is setted as state
            
            // Spreadhseet data
            const data = response.data.data;
            //update rows and columns for the spread
            setSpreadDim({
                rows: data.sheets[0].rows.length,
                columns: data.sheets[0].columns.length
            });
            // Shows teh spreadsheet
            setShowSpread(true);
            // Fills the spreadsheet
            fillSpreadSheet(data.sheets[0]);
        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error)
        }
    }

    // Fills the spreadsheet with the data
    const fillSpreadSheet = (data) => {
        let sheet = spread.current ? spread.current.widgetInstance.activeSheet() : null;

        if (sheet === null) {
            return;
        }

        // Fill the spreadsheet with the data
        sheet.fromJSON(data);
    }

    // When user selects a report from the select option
    const onSelectChange = (target) => {
        // sets the new selected report code as state
        setSelectedReport(target.value);
        // calls the appi to get the data
        getReportData(target.value);
    }

    return (
        <>
            <div className="sub_menu">
                <div className="sub_menu_btns my-1">
                    <button className="ilo-btn wizard_goBack_btn" onClick={goBack}> <BiArrowFromRight /> {t('wizard.goBack')}</button>
                </div>
            </div>
            <div className="container-fluid container_grid">
                <div className="row d-flex justify-content-center p-2">
                    <label className="d-flex align-items-center ilo_lbl_general" style={{marginRight:"15px"}}>{t('model.reports_combo')}</label>
                    <select onChange={(e) => { onSelectChange(e.target) }} className="form-control log_inputs" style={{ maxWidth: "400px" }}>
                        {reportsList.map((report) => {
                            return (
                                <option key={report.code} value={report.code}>
                                    {t(`model.${report.tag}`)}
                                </option>
                            );
                        })}
                    </select>
                </div>
                <div className="row row_attrs container_steps">
                    {
                        showSpread ?
                            <div className="col-md-12">
                                <Spreadsheet
                                    columns={spreadDim.columns}
                                    rows={spreadDim.rows}
                                    ref={spread}
                                ></Spreadsheet>
                            </div>
                            : showSpinner ?
                                <div className="col-md-12 d-flex justify-content-center">
                                    <Loader size="large" type="converging-spinner" />
                                </div>
                                :
                                <></>
                    }
                </div>
            </div>
        </>
    );
}

export default ModelReports